module.exports = __webpack_public_path__ + "img/landscape.f3b8aca2.png";